<template>
  <div class="expanded-row-container" :style="`width: ${dynamicWidth}px`">
    <div v-if="subBlockUrl" class="sub-block-container">
      <layout-builder
        class="layout-builder-sub"
        :url="subBlockUrl"
        :params="urlParams"
        :is-sub-block="true"
      ></layout-builder>
    </div>
    <template v-else>
      <div v-if="showActionButtons" class="action-buttons" :class="{ 'w-100': !showDetailView }">
        <expanded-row-buttons v-if="areButtonsLoaded" :row-id="rowId" />
        <action-button-skeleton v-else />
      </div>
      <div v-if="showDetailView" class="detail-view" :class="{ 'w-100': !showActionButtons }">
        <detail-view :expanded-data="expandedData" />
      </div>
    </template>
  </div>
</template>

<script>
import ActionButtonSkeleton from '../ActionButtonSkeleton'
import DetailView from '../detail-view/DetailView'
import ExpandedRowButtons from './ExpandedRowButtons'
import LayoutBuilder from '../../../layout-manager/layout-builder/LayoutBuilder'
import { get, pickBy, isPlainObject } from 'lodash'
import { parseMultiColumnName } from '../../../../utils/list'

export default {
  name: 'GridViewExpandedRow',
  components: {
    ActionButtonSkeleton,
    DetailView,
    ExpandedRowButtons,
    LayoutBuilder,
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    subBlockUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parentWidth: this.$parent.$parent.$el.clientWidth,
      urlParams: { [this.row.ID_NAME]: this.row.ID_VALUE },
    }
  },
  computed: {
    areButtonsLoaded() {
      return get(this.rowDetails, [this.rowId, 'status'], 'pending') === 'success'
    },
    availableInDetailView() {
      return this.$get('availableInDetailView')
    },
    columns() {
      return this.$get('columns')
    },
    dynamicWidth() {
      return this.parentWidth
    },
    expandedData() {
      const data = {}
      if (this.mongoList) {
        this.availableInDetailView.forEach((columnPath) => {
          if (isPlainObject(get(this.row, [columnPath]))) {
            data[`${columnPath}`] = get(this.row, [columnPath, 'content'])
          } else {
            data[`${columnPath}`] = get(this.row, columnPath)
          }
        })
        return data
      } else {
        const filtered = pickBy(this.row, (column, data) => {
          return this.availableInDetailView.includes(parseMultiColumnName(data))
        })
        return Object.entries(filtered).reduce((dataOnly, [columnName, value]) => {
          if (isPlainObject(value)) {
            dataOnly[columnName] = value.content
          } else {
            dataOnly[columnName] = value
          }
          return dataOnly
        }, {})
      }
    },
    extendedOptions() {
      return this.$get('extendedOptions')
    },
    mongoList() {
      return this.$get('mongoList')
    },
    rowDetails() {
      return this.$get('rowDetails')
    },
    rowId() {
      return get(this.row, 'ROW_KEY')
    },
    showActionButtons() {
      return this.visibilityState({ key: 'showActionButtons' })
    },
    showDetailView() {
      return this.visibilityState({ key: 'showDetailView' })
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
  },
  methods: {
    onResize() {
      this.parentWidth = this.$parent.$parent.$el.clientWidth
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style lang="scss" scoped>
.expanded-row-container {
  display: flex;
  position: sticky;
  left: 0;
  padding: 0 15px;
  .sub-block-container {
    width: 100%;
  }
  &.split-row-container {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 15px;
  }
  .action-buttons {
    width: 40%;
    margin-inline-end: 15px;
  }
  .detail-view {
    width: 60%;
  }
}
</style>
